var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImpact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9198 22.29H9.37049L8.55182 15.7406H16.7385L15.9198 22.29ZM20.6354 10.1245C20.3007 10.4159 19.9102 10.6362 19.4878 10.772C19.0654 10.9078 18.6197 10.9564 18.178 10.9147C17.7362 10.8731 17.3075 10.7421 16.9179 10.5297C16.5283 10.3173 16.1859 10.0279 15.9116 9.67914C15.6372 9.33037 15.4366 8.92949 15.3219 8.50083C15.2073 8.07217 15.1809 7.62467 15.2445 7.18551C15.308 6.74635 15.4602 6.32468 15.6917 5.94612C15.9232 5.56756 16.2292 5.23999 16.5911 4.98331C17.9993 3.86992 22.4692 4.52486 22.4692 4.52486C22.4692 4.52486 22.0598 9.01116 20.6354 10.1245Z",
    stroke: "#BABABA",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9198 9.42071C14.9732 10.1964 14.1946 11.1569 13.6316 12.2435C13.0685 13.3301 12.7329 14.5201 12.6452 15.7408C12.6452 10.8288 10.1892 7.55415 6.09583 5.09814",
    stroke: "#BABABA",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50884 8.37264C4.3105 9.06117 5.34264 9.42149 6.39864 9.38147C7.45463 9.34145 8.45654 8.90403 9.20378 8.15679C9.95102 7.40956 10.3884 6.40765 10.4285 5.35165C10.4685 4.29565 10.1082 3.26351 9.41963 2.46185C7.78229 0.840891 2.00249 1.00462 2.00249 1.00462C2.00249 1.00462 1.87151 6.7353 3.50884 8.37264Z",
    stroke: "#BABABA",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpact);
export default __webpack_public_path__ + "static/media/impact.b5e65690223632e24849a74d2a57533c.svg";
export { ForwardRef as ReactComponent };